import { yupResolver } from '@hookform/resolvers/yup'
import { useCallback, useEffect, useRef, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import * as yup from 'yup'
import { ApplyPcContent, Footer, SuccessPopupWithDownloadApp } from '../../common'
import { applyConfig, commonConfig } from '../../configs'
import { ApplicationHeader } from './local-components/ApplicationComponents'
import { bizNumFormat14Digit } from '../../tools'

const BizNoField = ({ useFormState, formRef, setAble2Submit, setFranchiseName }) => {
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    watch,
    reset,
    setError,
    clearErrors,
    formState: { errors }
  } = useFormState
  const [isLoading, setIsLoading] = useState(true)
  const bizNo = watch('biz_no')
  const [bizNoHelper, setBizNoHelper] = useState()
  const [shopName, setShopName] = useState()
  const [ownerName, setOwnerName] = useState()
  useEffect(() => {
    if (typeof window !== 'undefined' && formRef?.current) {
      const sp = new URLSearchParams(window.location.search)
      const v = sp.get('bizNo')
      if (v) {
        const biz_no = formRef?.current?.querySelector('#biz_no')
        if (biz_no) {
          biz_no.value = bizNumFormat14Digit(v)
          //   formRef.current.querySelector('#biz_no_btn').click()
          //   biz_no.focus()
          setValue('biz_no', v)
          setTimeout(() => {
            setIsLoading(false)
            formRef.current.querySelector('#biz_no_btn').click()
          }, 100)
        }
      }
    }
  }, [])

  const onChangeBizNo = e => {
    let text = e.target.value
    setValue(
      'biz_no',
      text
        .replace(/[^0-9.]/g, '')
        .replace(/(\..*?)\..*/g, '$1')
        .replace(/^0[^.]/, '0')
    )
  }

  const isBtnDisabled = bizNo ? false : true
  const param = useParams()
  const checkBizNo = async () => {
    try {
      const managerCode = param.manager_code
      const result = await applyConfig.applyBizNoValid(
        {
          biz_no: bizNo,
          manager_code: managerCode,
          bizTrans: new URLSearchParams(window.location.search).get('bizTrans')
        },
        '/api/v1/apply/spge-cf/applyBizNoValid'
      )

      if (result?.payload?.branch?.franchise_name) {
        setFranchiseName(result.payload.branch.franchise_name)
      }
      
      if (
        result?.payload?.responseType === 'ABLE_TO_MOVE_SHOP_FROM_CR_TO_CF' ||
        result?.payload?.responseType === 'SHOP_CF_EXISTED_IN_ANOTHER_BRAND'
      ) {
        const { shop_name, owner_name, shop_idx } = result.payload['shop']
        setBizNoHelper('')
        setAble2Submit(true)
        setShopName(shop_name)
        setOwnerName(owner_name)
        setValue('shop_idx', shop_idx)
        return
      }

      // alert(getValues('biz_no'))
      // const data = await commonConfig.apiGetShopByBizNo({
      //   biz_no: getValues('biz_no')
      // })
      // const { shop_name, owner_name, shop_idx, platform_idx, platform_sub_idx, partner_idx, franchise_manager_idx, ceo_type, shop_group } = data
      // console.log('data: ', data)
      // if (platform_idx) {
      //   if (ceo_type === 'PREMIUM' && (shop_group === 'SPGE_CR' || !shop_group)) {
      //     // CEO SPONGE PREMIUM => ok
      //     setBizNoHelper('')
      //     setAble2Submit(true)
      //     setShopName(shop_name)
      //     setOwnerName(owner_name)
      //     setValue('shop_idx', shop_idx)
      //     return
      //   }
      // }
    } catch (error) {}
    setBizNoHelper('초대받은 전화번호가 아닙니다. 담당자에게 문의해주세요.')
    setAble2Submit(false)
    setShopName()
    setOwnerName()
    setValue('shop_idx', 0)
  }
  const cautionText = (function () {
    if (isLoading) return
    if (!bizNo) return '필수정보입니다'
    return bizNoHelper ?? errors.biz_no?.message
  })()
  return (
    <>
      <div
        id="biz_no_field"
        className="customer_box"
        style={{
          marginTop: '30px'
        }}>
        <label htmlFor="biz_no">사업자 등록번호</label>
        <div className="input_btn_box">
          <input
            type="text"
            id="biz_no"
            {...register('biz_no', {
              onChange: e => onChangeBizNo(e)
            })}
            className={errors.biz_no ? 'error' : ''}
            autoComplete="off"
            style={{
              maxWidth: '100%'
            }}
          />
          {cautionText && <p className="caution color_r">{cautionText}</p>}
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              padding: '16px 0 22px 0',
              width: '100%'
            }}>
            <button
              id="biz_no_btn"
              type="button"
              className={'btn_style ' + (bizNoHelper ? 'error' : '')}
              style={{ fontWeight: '500', width: '239px', background: '#2F80ED', color: 'white' }}
              disabled={isBtnDisabled}
              onClick={() => checkBizNo()}>
              사업자 번호 검증
            </button>
          </div>
        </div>
      </div>
      <InfoDisplayField shop_name={shopName} owner_name={ownerName} />
    </>
  )
}

export const InfoDisplayField = ({ shop_name, owner_name }) => {
  return (
    <>
      <div
        style={{
          height: '95px',
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          fontSize: '16px',
          fontWeight: '500',
          border: '1.5px solid rgba(224, 224, 224, 1)',
          padding: '0 19px'
        }}>
        <p style={{ lineHeight: '24px' }}>사업자 상호: {shop_name}</p>
        <p style={{ lineHeight: '24px' }}>대표자명: {owner_name}</p>
      </div>
      <div
        style={{
          borderBottom: '1.5px solid rgba(224, 224, 224, 1)',
          paddingBottom: '11px',
          paddingTop: '9px',
          marginBottom: '27px'
        }}>
        <p className="color_blue font_nomal" style={{ lineHeight: '24px' }}>
          {/* 신청자 휴대폰번호로 스폰지C 서비스 관련 알림톡이 발송됩니다. */}
          스폰지R 서비스 프랜차이즈 가맹점 신청서에서 약관에 동의하신 내용에 따라 아래와 같이 프랜차이즈에 가맹점 정보를 제공합니다.
        </p>
      </div>
    </>
  )
}

export const FranchiseTableDisplay = ({ franchiseName }) => {
  const LocalRow = ({ text1, text2, boder }) => {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          borderBottom: boder ? '1px solid rgba(224, 224, 224, 1)' : 'none'
        }}>
        <span
          style={{
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            padding: '0 18px',
            fontWeight: '500',
            fontSize: '14px',
            lineHeight: '24px',
            backgroundColor: 'rgba(224, 224, 224, 1)',
            flex: '0 0 118px'
          }}>
          {text1}
        </span>
        <span
          style={{
            padding: '0 18px'
          }}>
          {text2}
        </span>
      </div>
    )
  }
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateRows: '1fr 1fr 1fr',
        height: '208px',
        border: '1.5px solid rgba(224, 224, 224, 1)',
        boxSizing: 'content-box'
      }}>
      <LocalRow boder={true} text1="프랜차이즈명" text2={franchiseName} />
      <LocalRow boder={true} text1="정보 제공 목적" text2={'프랜차이즈의 가맹점 관리 '} />
      <LocalRow
        boder={false}
        text1="정보 제공 항목"
        text2={'사업자 등록번호, 가맹점명, 대표자명, 대표자 휴대폰번호, 연동된 배달앱 계정에서 수집되는 고객리뷰'}
      />
    </div>
  )
}

function ConfirmSpongeCF() {
  const formRef = useRef()
  const location = useLocation()
  const navi = useNavigate()
  const [managerName, setManagerName] = useState() // 메니저 이름
  const [btnState, setBtnState] = useState(false) // 시작 예상
  const [bizNoTrue, setBizNoTrue] = useState(false)
  const [able2Submit, setAble2Submit] = useState(false)
  const [franchiseName, setFranchiseName] = useState('')
  const [successPopupState, setSuccessPopupState] = useState(false) // 성공 팝업 상태
  const [errorPopupState, setErrorPopupState] = useState(false) // 실패 팝업 상태
  const formSchema = yup.object({
    biz_no: yup //사업자 정보
      .string()
      .required('필수정보입니다.')
      .matches(/^[0-9]+$/, '숫자만 입력해주세요.')
      .test(
        'length-check',
        '사업자번호는 10자리 또는 14자리를 입력해주세요.', 
        value => value?.length === 10 || value?.length === 14 
      )
  })

  const useFormState = useForm({
    mode: 'onChange',
    resolver: yupResolver(formSchema),

    defaultValues: {
      biz_no: '',
      shop_idx: 0,
      franchise_idx: 0
    }
  })
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    watch,
    reset,
    setError,
    clearErrors,
    formState: { errors }
  } = useFormState
  const param = useParams()

  const getMangerVerf = useCallback((_, setManagerName, setFranchiseName) => {
    const managerCode = param.manager_code
    if (managerCode === 'fill') {
      console.log('no manager code')
      return
    }
    const data = {
      manager_code: managerCode || ''
    }

    commonConfig
      .spgeCfMangerVerify(data)
      .then(result => {
        setFranchiseName(result.franchise_name)
        setValue('franchise_idx', result.franchise_idx)
        setValue('franchise_manager_idx', result?.payload?.franchise_manager_idx)
        setManagerName(result.manager_name)
        if (result.result_code !== '00000') {
          alert('유효한 매니저코드가 아닙니다.')
          navi('/')
        }
      })
      .catch(error => {
        console.log(error)
      })
  }, [])

  useEffect(() => {
    if (param.manager_code) {
      getMangerVerf(param, setManagerName, setFranchiseName)
    }
  }, [])
  const onSubmit = async item => {
    const data = {
      biz_no: item?.biz_no.replace(/-/g, ''),
      shop_idx: item.shop_idx,
      franchise_manager_idx: item.franchise_manager_idx,
      bizTrans: new URLSearchParams(window.location.search).get('bizTrans'),
      manager_code: param.manager_code
    }
    applyConfig
      .apiConfirmJoinFranchise(data)
      .then(result => {
        console.log(result)
        setSuccessPopupState(true)
      })
      .catch(error => {
        console.log(error)
        // setErrorPopupState(true)
        alert(error?.message)
      })
  }
  return (
    <div className={'Application SubPages'}>
      <div className={'application_wrap'}>
        <ApplyPcContent /> {/* 1024 이상 display */}
        <div className={successPopupState || errorPopupState ? 'application_sheet notScroll' : 'application_sheet 2'} ref={formRef}>
          <ApplicationHeader location={location} managerName={managerName} isSpgeCFConfirm={true} />
          <div className="customer_wrap">
            <p className="wrap_tit">
              사업자 정보<span className="color_r">*</span>
            </p>
            <form className="application_form_wrap" onSubmit={handleSubmit(onSubmit)}>
              <BizNoField useFormState={useFormState} setAble2Submit={setAble2Submit} formRef={formRef} setFranchiseName={setFranchiseName} />
              <FranchiseTableDisplay franchiseName={franchiseName} />
              <button
                style={{
                  margin: '41px 40px 0 40px',
                  width: 'calc(100% - 80px)',
                  backgroundColor: 'rgba(3, 126, 219, 1)',
                  fontWeight: '500',
                  color: 'white',
                  opacity: able2Submit ? 1 : 0.5,
                  cursor: able2Submit ? 'pointer' : 'default'
                }}
                disabled={!able2Submit}
                type="submit"
                className={'btn_style'}>
                정보 제공 동의하기
              </button>
            </form>
          </div>
          <Footer />
          <SuccessPopupWithDownloadApp open={successPopupState} />
        </div>
      </div>
    </div>
  )
}

export { ConfirmSpongeCF }
